import { L as LocomotionSchema } from "../Locomotion-379972de.js";
import { R as RadiusSchema } from "../Radius-89a665f8.js";
import { T as TransformSchema } from "../Transform-9450b7b5.js";
import { C as CollisionsSchema } from "../Collisions-9e9492fb.js";
import { lengthVector2d, distanceSquaredVector2d } from "./vector.js";
import "../decorators/type.js";
import "ajv";
import "./clone.js";
import "bitecs";
import "./typehelpers.js";
import "../enums-86f58524.js";
import "../global-33d5eebf.js";
import "../components/ComponentRegistry.js";
import "../components/types.js";
import "./byteArray.js";
const emptyArray = [];
const checkCollisionFilter = (entity, filter, gameModel) => {
  const collisionsSchema = gameModel.getTypedUnsafe(gameModel.coreEntity, CollisionsSchema);
  if (!collisionsSchema.collisions[entity] || !collisionsSchema.collisions[entity].filters || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  !collisionsSchema.collisions[entity].filters[filter]) {
    return emptyArray;
  }
  return collisionsSchema.collisions[entity].filters[filter];
};
const pointsInSpatialMap = (cellSize, position, radius = 0, stretchPoint) => {
  let left = Math.floor((position.x - radius) / cellSize);
  let right = Math.floor((position.x + radius) / cellSize);
  let top = Math.floor((position.y - radius) / cellSize);
  let bottom = Math.floor((position.y + radius) / cellSize);
  if (stretchPoint) {
    left = Math.min(left, Math.floor((stretchPoint.x - radius) / cellSize));
    right = Math.max(right, Math.floor((stretchPoint.x + radius) / cellSize));
    top = Math.min(top, Math.floor((stretchPoint.y - radius) / cellSize));
    bottom = Math.max(bottom, Math.floor((stretchPoint.y + radius) / cellSize));
  }
  const pointSet = /* @__PURE__ */ new Set();
  for (let x = left; x <= right; x++) {
    for (let y = top; y <= bottom; y++) {
      pointSet.add(`${x}-${y}`);
    }
  }
  return pointSet;
};
const fromSpatialMap = (position, map, radius, filter) => {
  const pointSet = pointsInSpatialMap(map.cellSize, position, radius);
  const result = /* @__PURE__ */ new Set();
  if (filter) {
    pointSet.forEach((point) => {
      if (map.hash[point]) {
        map.hash[point].forEach((e) => e !== filter && result.add(e));
      }
    });
  } else {
    pointSet.forEach((point) => {
      if (map.hash[point]) {
        map.hash[point].forEach((e) => result.add(e));
      }
    });
  }
  return Array.from(result);
};
const circleCircleVector2d = (origin1, radius1, origin2, radius2) => {
  return circleCircleCollision(origin1.x, origin1.y, radius1, origin2.x, origin2.y, radius2);
};
const circleCircleCollision = (x1, y1, r1, x2, y2, r2) => {
  const r = r1 + r2;
  const dx = x1 - x2;
  const dy = y1 - y2;
  return r * r > dx * dx + dy * dy;
};
const spatialMap = (gameModel, entities, cellSize, pointSets) => {
  const map = {
    cellSize,
    hash: {},
    hasEntities: entities.length > 0
  };
  for (let i = 0; i < entities.length; i++) {
    const transformSchema = gameModel.getTypedUnsafe(entities[i], TransformSchema);
    const position = transformSchema.position;
    RadiusSchema.id = entities[i];
    let radius = RadiusSchema.radius;
    if (!radius) {
      continue;
    }
    const locomotionSchema = gameModel.getTypedUnsafe(entities[i], LocomotionSchema);
    const speed = lengthVector2d(locomotionSchema.velocity);
    radius += speed;
    const stretchPoint = void 0;
    const pointSet = pointsInSpatialMap(cellSize, position, radius, stretchPoint);
    pointSets[entities[i]] = pointSet;
    pointSet.forEach((point) => {
      if (!map.hash[point]) {
        map.hash[point] = [];
      }
      map.hash[point].push(entities[i]);
    });
  }
  return map;
};
const fastEntityCollision = (gameModel, entity, player, radius) => {
  let transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
  const position = transformSchema.position;
  transformSchema = gameModel.getTypedUnsafe(player, TransformSchema);
  const playerPosition = transformSchema.position;
  RadiusSchema.id = player;
  const playerRadius = RadiusSchema.radius;
  return circleCircleVector2d(position, radius, playerPosition, playerRadius);
};
const sortedByDistance = (gameModel, entityPosition, entities, maxRadius = Infinity) => {
  const distances = {};
  const radiusSquared = maxRadius * maxRadius;
  if (entities.length === 1 && maxRadius < Infinity) {
    const transformSchema = gameModel.getTypedUnsafe(entities[0], TransformSchema);
    const distance = distanceSquaredVector2d(entityPosition, transformSchema.position);
    if (distance < radiusSquared) {
      return entities;
    }
    return [];
  }
  return entities.sort((a, b) => {
    if (!distances[a]) {
      const transformSchema = gameModel.getTypedUnsafe(a, TransformSchema);
      const distance = distanceSquaredVector2d(entityPosition, transformSchema.position);
      if (distance < radiusSquared) {
        distances[a] = distance;
      } else {
        distances[a] = Infinity;
      }
    }
    if (!distances[b]) {
      const transformSchema = gameModel.getTypedUnsafe(b, TransformSchema);
      const distance = distanceSquaredVector2d(entityPosition, transformSchema.position);
      if (distance < radiusSquared) {
        distances[b] = distance;
      } else {
        distances[b] = Infinity;
      }
    }
    return distances[a] - distances[b];
  }).filter((e) => distances[e] !== Infinity);
};
const closestEntity = (gameModel, entityPosition, entities, radius = Infinity) => {
  return sortedByDistance(gameModel, entityPosition, entities, radius)[0];
};
export {
  checkCollisionFilter,
  circleCircleCollision,
  circleCircleVector2d,
  closestEntity,
  fastEntityCollision,
  fromSpatialMap,
  sortedByDistance,
  spatialMap
};
//# sourceMappingURL=Collision.js.map
